import { getStarted_FlexPane_Title } from 'owa-locstrings/lib/strings/getstarted_flexpane_title.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import HeaderFlexPane from './HeaderFlexPane';
import HeaderPaneProps from './HeaderPaneProps';
import { observer } from 'mobx-react-lite';
import { GetStartedListInFlexPane } from 'owa-getstarted';

export default observer(function GetStatedPane({ onDismiss }: HeaderPaneProps) {
    return (
        <HeaderFlexPane
            title={loc(getStarted_FlexPane_Title)}
            content={<GetStartedListInFlexPane />}
            onDismiss={onDismiss}
        />
    );
});
